module.exports = __webpack_public_path__ + "media/images/flags/lu-573059db5f8f4570b5c51997665e04b0.svg";